import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpBackend from 'i18next-http-backend';
import { SHARED_LANG_COOKIE, sharedCookieDomain } from '@easydent/shared-ui';

i18n
  .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    supportedLngs: ['en', 'ro'],
    defaultNS: 'common',
    ns: ['common', 'auth', 'patients', 'appointments', 'clinical', 'settings'],
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
    },
    detection: {
      // A language carried from another app wins: ?lang= (a cross-app hop) → the shared
      // parent-domain cookie → this app's own localStorage → the browser. New choices are cached
      // back to localStorage *and* the shared cookie so the other apps inherit them.
      order: ['querystring', 'cookie', 'localStorage', 'navigator'],
      lookupQuerystring: 'lang',
      lookupCookie: SHARED_LANG_COOKIE,
      caches: ['localStorage', 'cookie'],
      cookieDomain: sharedCookieDomain(),
      cookieMinutes: 525600, // 1 year
    },
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
